import React from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaTrash } from 'react-icons/fa';
import './Toast.css';

const Toast = ({ show, onClose, message, type = 'success', duration = 3000 }) => {
  React.useEffect(() => {
    if (show && duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="toast-icon success" />;
      case 'error':
        return <FaExclamationCircle className="toast-icon error" />;
      case 'info':
        return <FaInfoCircle className="toast-icon info" />;
      case 'delete':
        return <FaTrash className="toast-icon delete" />;
      default:
        return <FaCheckCircle className="toast-icon success" />;
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success!';
      case 'error':
        return 'Error!';
      case 'info':
        return 'Info';
      case 'delete':
        return 'Deleted!';
      default:
        return 'Success!';
    }
  };

  return (
    <div className={`custom-toast-container ${show ? 'show' : ''}`}>
      <BootstrapToast
        show={show}
        onClose={onClose}
        className={`custom-toast ${type}`}
        animation={true}
      >
        <BootstrapToast.Header closeButton={false}>
          {getIcon()}
          <strong className="me-auto">{getTitle()}</strong>
        </BootstrapToast.Header>
        <BootstrapToast.Body>{message}</BootstrapToast.Body>
      </BootstrapToast>
    </div>
  );
};

export default Toast;
